module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ksm-flex-1 ksm-flex-column"
  }, [_c('div', {
    staticClass: "ksm-flex-1 ksm-flex"
  }, [_c('div', {
    staticClass: "ksm-flex-00auto"
  }, [_c('div', {
    staticClass: "ksm-medien__icon",
    domProps: {
      "innerHTML": _vm._s(_vm.$_getSvg('audio.svg'))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ksm-flex-1",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "ksm-media-wrapper"
  }, [_c('div', {
    staticClass: "ksm-flex-1",
    staticStyle: {
      "text-align": "center",
      "position": "relative"
    }
  }, [_c('div', {
    staticStyle: {
      "position": "absolute",
      "width": "100%",
      "height": "100%"
    }
  }, [_c('img', {
    staticClass: "ksm-schallplatten",
    staticStyle: {
      "max-height": "100%",
      "max-width": "100%",
      "bottom": "0"
    },
    attrs: {
      "src": _vm.selected_audio === 'Audio1924' ? _vm.$_getIcon('1923.png') : _vm.$_getIcon('1932.png')
    }
  })])]), _vm._v(" "), _c('audio', {
    staticClass: "ksm-media"
  }, [_c('source', {
    attrs: {
      "src": './static/multimedia/' + _vm.audioSrc,
      "type": "audio/mpeg"
    }
  }), _vm._v("Your browser does not support the audio element.\n        ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "ksm-flex-00auto ksm-flex"
  }, [_c('div', {
    staticClass: "ksm-flex-00auto ksm-flex-column"
  }, [_c('div', [_c('div', {
    staticClass: "ksm-medien__audio-select"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selected_audio),
      expression: "selected_audio"
    }],
    attrs: {
      "type": "radio",
      "name": "ksm_audio_radio",
      "id": "ksm-radio__audio-1924",
      "value": "Audio1924"
    },
    domProps: {
      "checked": _vm._q(_vm.selected_audio, "Audio1924")
    },
    on: {
      "change": function($event) {
        _vm.selected_audio = "Audio1924"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "ksm-radio__audio-1924"
    }
  }, [_vm._v("Originalaufnahme 1924")])]), _vm._v(" "), _c('div', {
    staticClass: "ksm-medien__audio-select"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selected_audio),
      expression: "selected_audio"
    }],
    attrs: {
      "type": "radio",
      "name": "ksm_audio_radio",
      "id": "ksm-radio__audio-1932",
      "value": "Audio1932"
    },
    domProps: {
      "checked": _vm._q(_vm.selected_audio, "Audio1932")
    },
    on: {
      "change": function($event) {
        _vm.selected_audio = "Audio1932"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "ksm-radio__audio-1932"
    }
  }, [_vm._v("Originalaufnahme 1932")])])])]), _vm._v(" "), _c('div', {
    staticClass: "ksm-flex-1 ksm-flex-column"
  }, [_c('div', {
    staticClass: "ksm-flex-1 ksm-flex"
  }), _vm._v(" "), _c('div', {
    staticClass: "ksm-flex-00auto"
  }, [(_vm.media) ? _c('PlayerControls', {
    attrs: {
      "media": _vm.media,
      "mediaType": "audio",
      "mediaName": _vm.selected_audio
    },
    on: {
      "audioChange": _vm.audioChange,
      "playPause": _vm.playPause
    }
  }) : _vm._e()], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8cebb756","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/texte/ursonate/AudioView.vue
// module id = 1985
// module chunks = 1